import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const selectModelosCartaState = (state: RootState) => state.secretariaArbitralModelosCarta;

export const selectModelosCartaAr = createSelector([selectModelosCartaState], (modelos) => ({
  items: modelos.items,
  total: modelos.total,
  page: modelos.page,
  limit: modelos.limit,
  hasMore: modelos.hasMore,
  search: modelos.search,
  loading: modelos.loading,
  error: modelos.error,
}));
